import Vue from "vue";
import Vuex from "vuex";
import Api from "@/api/index";
import { getToken, setToken, removeToken } from "../utils/auth";
import im from './modules/im'

Vue.use(Vuex);
// let accountApi =  api.accountApi;

export default new Vuex.Store({
  state: {
    apiMessage: "",
    token: "",
    cookieToken: getToken(),
    message: 0,
    user: {},
    status_origin:0,
    post_id:'',
    imReadyState: false,
    orderStatus: [],
    config: {},
    permission: {},
    jobHarfView: false,
    addCompany: false
  },
  getters: {
    isLogin(state) {
      return !!state.token;
    },
    isGranted: state => payload => {
      if (payload) {
        return state.permission[payload] ? true : false;
      } else {
        return true;
      }
    },
    isAnyGranted: (state, getters) => payload => {
      return payload.some(item => getters.isGranted(item));
    },
    orderStatus: state => payload => {
      return state.orderStatus[payload];
    },
    getUsers(state) {
      return state.user
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = { ...payload };
    },
    updateImState(state, payload) {
      state.imReadyState = payload;
    },
    addCompany(state, payload) {
      this.state.addCompany = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setCookieToken(state, payload) {
      state.cookieToken = payload;
    },
    setConfig(state, payload) {
      Object.assign(state.config, { ...payload });
    },
    setMessage(state, payload) {
      state.message = payload;
    },
    pushMessage(state, payload) {
      state.apiMessage = payload;
    },
    setPermission(state, payload) {
      state.permission = { ...payload };
    },
    setOrderStatus(state, payload) {
      state.orderStatus = { ...payload };
    },
    toggleJobView(state) {
      state.jobHarfView = !state.jobHarfView;
    },
    setPostId(state, val) { //设置参数
      state.post_id = val;
    },
    setStatus(state,val) {
      state.status_origin = val
    }
  },
  actions: {
    async login({ commit }, payload) {
      let response = await Api.account.login(payload);
      commit("setUser", response.user);
      commit("setToken", response.token);
      setToken(response.token);
      
      localStorage.setItem('is_gray', response.is_gray ? "1" : "0")
      localStorage.setItem('userJobInfo', JSON.stringify(response.user))
    },
    async logout({ commit, state, dispatch }) {
      dispatch('im/logout')
      await Api.account.logout();
      removeToken();
      commit("setCookieToken", null);
      commit("setToken", null);

    },
    async doLogin({ commit, state, getters }) {
      let token = state.cookieToken;
      // 用户未执行登录但存有token,执行认证登录
      if (!getters.isLogin && token) {
        try {
          commit("setToken", token);
          let response = await Api.account.doLogin();
          commit("setUser", response.user);
          // localStorage.setItem('is_gray', JSON.stringify(response.is_gray))
          setToken(response.token);
        } catch (e) {
          removeToken();
          commit("setCookieToken", null);
          commit("setToken", null);
          commit("is_gray", null);
        }
      }
    },
    pushMessage({ commit }, payload) {
      commit("pushMessage", payload);
      setTimeout(() => {
        commit("pushMessage", "");
      }, 100);
    }
  },
  modules: { im }
});
